import { IIndexMeta } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/authorizationsConsultation/showDetails/IndexMeta';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import displayCustomField from '@Shared/utils/displayCustomFields';
import { getDetailName } from '@Shared/utils/getDetailName';
import React from 'react';
type Props = {
  meta: IIndexMeta,
} 


const IndexMainUI = ({meta}: Props) => {
  
  const indexDataInformations1 = React.useMemo(() => getDetailName(meta).slice(0, 9), [meta]);
  const indexDataInformations2 = React.useMemo(() => getDetailName(meta).slice(9, 13), [meta]);

  return (
    <>      
        <CC.Box my="4" mb='8'>
          <CC.SimpleGrid columns={{ base: 1, md:2  }} gridRowGap={4} columnGap={10} my={4}>
              {displayCustomField<IIndexMeta>(
              meta, indexDataInformations1
              )}
          </CC.SimpleGrid>
        </CC.Box>
        <CC.Divider/>
        <CC.Box my="4" mb='8'>
          <CC.SimpleGrid columns={{ base: 1, lg: 2 }} gridRowGap={4} columnGap={10} my={4}>
              {displayCustomField<IIndexMeta>(
              meta, indexDataInformations2
              )}
          </CC.SimpleGrid>
        </CC.Box>
    </>    
  )
}

export default IndexMainUI;